import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import bgVideo from "../assets/contact_form.mp4";
import sinlogo from "../assets/sinlogo.png";

const gradient = "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)";

const ThankYou = () => {
  useEffect(() => {
    document.title = "Thank you | SINTX";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .ty-btn {
          transition: background .2s, color .2s, transform .2s;
        }
        .ty-btn:focus-visible {
          outline: 2px solid #fff;
          outline-offset: 3px;
        }
        .ty-secondary:hover { background: rgba(255,255,255,0.15) !important; }
        .ty-wa:hover { color: #25D366 !important; }
        @media (prefers-reduced-motion: reduce) {
          .ty-video { display: none; }
        }
      `}</style>

      <section
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "48px 20px",
          boxSizing: "border-box",
          fontFamily: "'Poppins', sans-serif",
          overflow: "hidden",
          background: "#000",
        }}
      >
        <video
          className="ty-video"
          autoPlay
          loop
          muted
          playsInline
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src={bgVideo} type="video/mp4" />
        </video>

        <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.65)", zIndex: 1 }} />

        <motion.main
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          style={{
            position: "relative",
            zIndex: 2,
            width: "100%",
            maxWidth: 560,
            textAlign: "center",
            background: "rgba(255,255,255,0.05)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 24,
            padding: "clamp(32px, 6vw, 56px) clamp(20px, 5vw, 44px)",
            boxSizing: "border-box",
          }}
        >
          <img src={sinlogo} alt="Sintex Logo" width="140" style={{ marginBottom: 36 }} />

          {/* Success tick */}
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.25, type: "spring", stiffness: 200, damping: 14 }}
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: gradient,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 28px",
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="5,13 10,18 19,7" />
            </svg>
          </motion.div>

          <h1
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: "clamp(1.8rem, 5vw, 2.4rem)",
              fontWeight: 700,
              lineHeight: 1.15,
              color: "#fff",
              margin: "0 0 14px",
            }}
          >
            We got your message
          </h1>

          <p
            style={{
              fontSize: 15,
              lineHeight: 1.7,
              color: "rgba(255,255,255,0.6)",
              margin: "0 auto 36px",
              maxWidth: 400,
            }}
          >
            Thanks for reaching out. Our team will contact you within 24 hours.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 14, alignItems: "center" }}>
            <Link
              to="/"
              className="ty-btn"
              style={{
                display: "inline-block",
                padding: "13px 36px",
                borderRadius: 100,
                background: "#fff",
                fontSize: 14,
                fontWeight: 700,
                textDecoration: "none",
                backgroundImage: gradient,
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Back to home
            </Link>

            <a
              href="https://wa.me/919491105026?text=Hello%20Sintx!%20I%20just%20submitted%20the%20contact%20form."
              target="_blank"
              rel="noreferrer"
              className="ty-btn ty-wa"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontSize: 13,
                color: "rgba(255,255,255,0.55)",
                textDecoration: "none",
                marginTop: 4,
              }}
            >
              <FaWhatsapp size={18} />
              <span>Need a faster reply? Chat on WhatsApp</span>
            </a>
          </div>
        </motion.main>
      </section>
    </>
  );
};

export default ThankYou;